import Vue from "vue";
import firebase from 'firebase/compat/app';
import firebaseConfig from '../../firebaseConfig';
import axios from "axios";
import CryptoJS from "crypto-js";

const firebaseApp = firebase.initializeApp(firebaseConfig);

export default {};

export const functions = {
  install(Vue) {
    Vue.prototype.$functions = {
      call: async function (name, data) {
        var result = "";
        try {
          var callable = firebaseApp.functions('asia-northeast3').httpsCallable(name);
          result = await callable(data);
        }
        catch (e) {
          console.log(e);
        }
        return result;
      },
      sendKakao: async function (data) {
        // kakao 
        await axios.post('https://us-central1-doctor365-9a68d.cloudfunctions.net/sendKakao', JSON.stringify(data), {
          headers: {
            "Content-Type": "application/json",
          },
            }
          )
          .then(async function (response) {
            console.log('sendKakao:', response);
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getHospitalList: async function (phone) {
        // V2 Hospital Lists
        const apiUrls = {
          dev: "https://flydoctor-api-dev-41805375326.asia-northeast3.run.app",
          prd: "https://flydoctor-api-41805375326.asia-northeast3.run.app",
        };
        const apiKeys = {
          dev: "781614b7919f8a4a8009de8bf6438e0e",
          prd: "2291b22d4b7b552e0f6345d603f77a5b",
        };
        let url = "";
        let apiKey = "";
        let data = {};
        let stage = this.getStage();
        // console.log("* stage:", stage);
        if (stage === "dev") {
          url = apiUrls.dev;
          apiKey = apiKeys.dev;
        } else {
          url = apiUrls.prd;
          apiKey = apiKeys.prd;
        }
        url += "/external/partners/hospitals/";
        await axios
          .get(url, {
            params: {
              linked_phone_number: phone,
            },
            headers: {
              "X-API-Key": apiKey,
              "Content-Type": "application/json",
            },
          })
          .then(async function (response) {
            // console.log("getHospitalLists(V2):", response.data);
            data = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
        return data;
      },
      getStage: function () {
        const host = window.location.host;
        let stage = "prd";
        if (host.includes("localhost") || host.includes("dev")) {
          stage = "dev";
        }
        return stage;
      },
      encryptAES: function (text) {
        const secretKey = "1zwg5lokEZJ1YMZd";
        return CryptoJS.AES.encrypt(text, secretKey).toString();
      },
      decryptAES: function (encryptedText) {
        const secretKey = "1zwg5lokEZJ1YMZd";
        const bytes = CryptoJS.AES.decrypt(encryptedText, secretKey);
        return bytes.toString(CryptoJS.enc.Utf8);
      },
    }
  }
};

Vue.use(functions);